import { useClipsContext } from '@/context/ClipsContext/ClipsContext';
import { doesClipHaveMultipleScenes } from '@/player-config/src/utils/clipUtils';

const ClipCustomizerMultipleSceneWarning = () => {
  const { clipData } = useClipsContext();
  if (!doesClipHaveMultipleScenes(clipData)) {
    return null;
  }

  return (
    <div className="mt-5 rounded-md border border-black border-opacity-10 bg-orange-50 px-3 py-2.5">
      <div className="font-medium">Scene changes detected</div>
      <div className="mt-1 font-light">
        There are custom scene changes in the timeline – applying a global layout will overwrite all existing scene
        changes
      </div>
    </div>
  );
};

export default ClipCustomizerMultipleSceneWarning;
